module.exports = "<app-core-tasks *ngIf=\"visible\" block-title=\"Reeds gestart\" type=\"started\" [coreTasks]=\"startedCoreTasks$ | async\"></app-core-tasks>\r\n<app-core-tasks *ngIf=\"visible\" block-title=\"Nog niet gestart\" type=\"unstarted\" [coreTasks]=\"unstartedCoreTasks$ | async\"></app-core-tasks>\r\n<app-core-tasks *ngIf=\"visible\" block-title=\"Afgerond\" type=\"done\" [coreTasks]=\"finishedCoreTasks$ | async\"></app-core-tasks>\r\n<app-keuzedeel></app-keuzedeel>"


//////////////////
// WEBPACK FOOTER
// ./src/app/students/student/student.component.html
// module id = ./src/app/students/student/student.component.html
// module chunks = main